'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('CustomDataCtrl', CustomDataCtrl);

  CustomDataCtrl.$inject = ['$scope', '$state', '$stateParams', '$sessionStorage', 'customSignupSvc', 'countryGdprConfig', 'onboardingRouter', 'providerSvc', 'ssoAuthView', 'authenticationSvc', 'NotifyingSvc'];

  function CustomDataCtrl($scope, $state, $stateParams, $sessionStorage, customSignupSvc, countryGdprConfig, onboardingRouter, providerSvc, ssoAuthView, authenticationSvc, NotifyingSvc) {
    var isSso = $state.current.data.isSso ? true : false;
    var organization = null;
    $scope.saveCustomForm = _saveCustomForm;
    $scope.fields = [];

    var vm = this;
    vm.firstName = '';
    vm.cobrandingText = '';
    vm.cobranding = null;

    activate();

    function activate() {
      if (isSso) {
        _testForAccessDenied();

        authenticationSvc.getOrganizationBySsoIdp(ssoAuthView.attributesView.idpId, ssoAuthView.attributesView.accessCode).then(function (resp) {
          organization = resp.data;

          _getGDPRConfig(ssoAuthView.attributesView.accessCode);

          _getSsoCustomFields(ssoAuthView.attributesView.accessCode);
        });

        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.GET_AGREEMENTS, true);
      }
    }

    function _getGDPRConfig(accessCode) {
      customSignupSvc.checkAccessCode(accessCode).then(function (data) {
        countryGdprConfig.getByCountryCode(data.country.countryCode, data.applicationMode.name);
      });
    }

    function _getSsoCustomFields(accessCode) {
      customSignupSvc.setupCustomSignup(accessCode).then(function () {
        $scope.fields = customSignupSvc.getCustomFields('sso');

        if ($scope.fields && $scope.fields.length && !ssoAuthView.ssoUserMetadata.hasAcceptedTerms) {
          _getHeaderData(organization);
        } else {
          _determineSsoNextStep();
        }
      }, function () {
        _determineSsoNextStep();
      });
    }

    function _getHeaderData(organization) {
      vm.firstName = ssoAuthView.attributesView.firstName || '';
      vm.cobrandingText = organization.name;

      providerSvc.setProvider({
        accessCode: ssoAuthView.attributesView.accessCode,
        organization: organization.shortName
      }, true).then(function () {
        providerSvc.getHeader().then(function (data) {
          var contentItem = null;
          if (data && data.content) {
            contentItem = data.content.filter(function (headerContent) {
              return headerContent.target === 'image';
            })[0];
            if (contentItem) {
              vm.cobranding = contentItem.replacement;
            }
          }
        });
      });
    }

    function _saveCustomForm() {
      authenticationSvc.ssoLogin(ssoAuthView).then(function (res) {
        customSignupSvc.saveCustomSsoResponse(_prepareCustomBody(res.data.response.id, $scope.fields)).then(function () {
          _determineSsoNextStep();
          $sessionStorage.customFormStep = true;
        });
      }, function (err) {
        onboardingRouter.ssoMapLoginError(err, organization);
      });
    }

    function _prepareCustomBody(userId, fields) {
      var responses = fields.map(function (field) {
        return {
          signUpFieldName: field.name,
          response: field.response,
          signUpFieldCollectionId: field.collectionId
        };
      });

      return { userId: userId, responses: responses };
    }

    function _testForAccessDenied() {
      var ACCESS_DENIED_CODE = 'ACCESS_DENIED';
      var ssoError = ssoAuthView.ssoUserMetadata.userAttributeError;
      if (ssoError && ssoError.errorCode === ACCESS_DENIED_CODE) {
        onboardingRouter.navigateSsoError({
          contact: true
        });
      }
    }

    function _determineSsoNextStep() {
      var ssoUserMeta = ssoAuthView.ssoUserMetadata;

      if (ssoUserMeta.userAttributeError === null) {
        // No errors go to next step
        if (organization && organization.shortName === 'BSC') {
          onboardingRouter.navigateSsoCustomLanding();
        } else if (ssoUserMeta.hasAcceptedTerms === true) {
          onboardingRouter.navigateSsoLogin($stateParams);
        } else {
          onboardingRouter.navigateSsoLanding();
        }
      } else {
        onboardingRouter.ssoMapLoginError({ data: ssoUserMeta.userAttributeError }, organization);
      }
    }
  }
})();